// 401 errors are now handled by the httpService silent-refresh interceptor.
// This handler runs only for non-401 errors and success responses.
export const Interseptor = {
    requestHandler(request) {
        return request
    },
    errorHandler(error) {
        return Promise.reject(error)
    },
    successHandler(response) {
        return response
    }
}
